import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=3487eb68&scoped=true&"
import script from "./ControlPanel.vue?vue&type=script&lang=js&"
export * from "./ControlPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487eb68",
  null
  
)

export default component.exports